import { render, staticRenderFns } from "./mensagens-enviadas.vue?vue&type=template&id=409cc7bd&scoped=true&"
import script from "./mensagens-enviadas.vue?vue&type=script&lang=js&"
export * from "./mensagens-enviadas.vue?vue&type=script&lang=js&"
import style0 from "./mensagens-enviadas.vue?vue&type=style&index=0&id=409cc7bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409cc7bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
